export default __webpack_public_path__ + "static/media/851.5baf622a.png";